import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetetector from 'i18next-browser-languagedetector';
import HTTPApi from 'i18next-http-backend';
import translationEN from './locale/en/translation.json';
import translationHU from './locale/hu/translation.json';
import translationDE from './locale/de/translation.json';
import { support } from 'jquery';


const resources = {
  en: {
    translation: translationEN,
  },
  hu: {
    translation: translationHU,
  },
  de:{
    translation: translationDE,
  }
};


i18next
    .use(initReactI18next)
    .use(LanguageDetetector)
    .use(HTTPApi)
    .init({
        resources,
        fallbackLng: 'hu',
        supportedLngs: ['en', 'hu', 'de'],
        interpolation: {
          escapeValue: false,
        },
        detection:{
          order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
          caches: ['localStorage', 'cookie'],
        }
      });
    
export default i18next;